
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "fr",
  "es"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_index_46ts_3502eb79",
      load: () => import("#nuxt-i18n/3502eb79" /* webpackChunkName: "locale_index_46ts_3502eb79" */),
      cache: false
    }
  ],
  de: [
    {
      key: "locale_index_46ts_2bd8fe96",
      load: () => import("#nuxt-i18n/2bd8fe96" /* webpackChunkName: "locale_index_46ts_2bd8fe96" */),
      cache: false
    }
  ],
  fr: [
    {
      key: "locale_index_46ts_f84afac0",
      load: () => import("#nuxt-i18n/f84afac0" /* webpackChunkName: "locale_index_46ts_f84afac0" */),
      cache: false
    }
  ],
  es: [
    {
      key: "locale_index_46ts_747d95be",
      load: () => import("#nuxt-i18n/747d95be" /* webpackChunkName: "locale_index_46ts_747d95be" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/5b517311" /* webpackChunkName: "config_i18n_46config_46ts_5b517311" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      countryCode: "US",
      files: [
        {
          path: "/opt/atlassian/pipelines/agent/build/i18n/locales/en/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      name: "Deutsch",
      countryCode: "DE",
      files: [
        {
          path: "/opt/atlassian/pipelines/agent/build/i18n/locales/de/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "Français",
      countryCode: "FR",
      files: [
        {
          path: "/opt/atlassian/pipelines/agent/build/i18n/locales/fr/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      name: "Español",
      countryCode: "ES",
      files: [
        {
          path: "/opt/atlassian/pipelines/agent/build/i18n/locales/es/index.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    "account/professional-info": false,
    "account/profile-info": false,
    "account/subscription": false,
    "auth/about-you": false,
    "auth/forgot-password": false,
    "auth/login": false,
    "auth/reset-password": false,
    "auth/signup": false,
    "auth/verify-email": false,
    "enroll/[planGroup]": false,
    "enroll/new/[planGroup]": false,
    "enroll/thank-you": false,
    "groups/[groupId]/invite/accept": false,
    "groups/[groupId]/members/[memberId]": false,
    "groups/[groupId]/members/index": false,
    "groups/[groupId]/index": false,
    "tools/ai-prompting-tool": false,
    "webinars/[webinar]": false,
    "webinars/index": false,
    dashboard: false,
    pricing: false,
    courses: false
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    countryCode: "US",
    files: [
      {
        path: "/opt/atlassian/pipelines/agent/build/i18n/locales/en/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutsch",
    countryCode: "DE",
    files: [
      {
        path: "/opt/atlassian/pipelines/agent/build/i18n/locales/de/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    countryCode: "FR",
    files: [
      {
        path: "/opt/atlassian/pipelines/agent/build/i18n/locales/fr/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Español",
    countryCode: "ES",
    files: [
      {
        path: "/opt/atlassian/pipelines/agent/build/i18n/locales/es/index.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/